// extracted by mini-css-extract-plugin
export default {"card":"cZ-z","carouselContainer":"dZ-z","carouselContent":"eZ-z"};